

import VideoButton from "@/components/main/core/VideoButton"
export default {
  name: "ClientHead",
  props: ['title', 'title2', 'title3', 'link', 'type', 'height', 'nopad', 'mt'],
  components: {VideoButton},
}
